import { CustomTabList, Heading } from "@/components";
import { Card } from "@/components/ui";
import { capitalize } from "@/lib/utils";
import { Tabs, TabsContent } from "@radix-ui/react-tabs";
import { tabs } from "./consts";
import { InstallmentSchedule, SchoolInfo, LabInfo, InventoryInfo } from "./TabsData";
import SchoolSummaryCard from "./SchoolSummaryCard";
import useAdd from "./useAdd";
import { routes } from "@/routes/utils";
import { CrmMgmtInfo } from "./TabsData/CrmMgmt";
import { useGetSchoolByIdQuery } from "@/services";
import { useParams } from "react-router-dom";

const Add = () => {
  const { action, currentTab, onTabChange, onNextClick } = useAdd();
  const params = useParams();
  const id = (params?.id as string | undefined);

  const { data: schoolRes, isPending: isSchoolLoading } = useGetSchoolByIdQuery(
    id || "",
    { enabled: Boolean(id) } as any
  );

  const school = (schoolRes as any)?.data || {};


  return (
    <div className="p-7">
      <Heading
        title={
          <span>
            <span className="text-g-300">Onboarded School</span>
            <span className="mx-3">|</span>
            <span>{capitalize(action || "")} School
              {school?.schoolName ? ` (${school?.schoolName})` : ""}
            </span>
          </span>
        }
      />
      {(action === routes.edit || action === routes.view) && <SchoolSummaryCard />}
      {/* <Card className="py-5 pt-0 mt-6 shadow-none"> */}
        <Tabs
          defaultValue="1"
          className="mt-6"
          value={currentTab}
          onValueChange={onTabChange}
        >
          <CustomTabList
            tabs={tabs}
            className="mx-5"
            currentTab={currentTab}
            action={action}
          />
          <TabsContent value="1" className="px-0">
            <SchoolInfo onNextClick={onNextClick} />
          </TabsContent>
          <TabsContent value="2" className="px-0">
            <InstallmentSchedule onNextClick={onNextClick} />
          </TabsContent>
          <TabsContent value="3" className="px-0">
            <CrmMgmtInfo />
          </TabsContent>
          <TabsContent value="4" className="px-0">
            <InventoryInfo />
          </TabsContent>
          <TabsContent value="5" className="px-0">
            <LabInfo />
          </TabsContent>
        </Tabs>
      {/* </Card> */}
    </div>
  );
};

export default Add;
